import { render } from "./ContactPersonForm.vue?vue&type=template&id=4b31bc1c&scoped=true"
import script from "./ContactPersonForm.vue?vue&type=script&lang=js"
export * from "./ContactPersonForm.vue?vue&type=script&lang=js"

import "./ContactPersonForm.vue?vue&type=style&index=0&id=4b31bc1c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b31bc1c"]])

export default __exports__